import { borderRadius } from "@mui/system";
import { React, useRef } from "react";
import { newSessionUID } from "./commons";

// stretch: fill the container instead of scaling uniformly. The default keeps
// the SVG's own aspect ratio (xMidYMid meet), which means a taller container
// only re-centres the same artwork rather than growing it - fine for the fixed
// panels this is used for, wrong for a dialog whose height follows its content.
// frameless: draw the artwork without the bordered frosted rectangle that
// .main-bg-overlay:before paints. The frame is what makes an empty panel read as
// a dialog, so a screen that wants the glow while its contents are hidden asks
// for the glow alone.
export function MainBg2({ isDarkMode = false, width = "100%", height = "100%", stretch = false, frameless = false }) {
  /* the clip below is sized from this instance's own panel, so it cannot share
     an id with another one on the page - and it is kept for the life of the
     component, so a re-render does not rewrite the reference */
  const uNameRef = useRef(null);
  if (!uNameRef.current) uNameRef.current = newSessionUID();
  const uName = uNameRef.current;

  const sData = {
    x: 30,
    y: 15,
    width: width == "100%" ? 1245 : width - 60,
    height: height == "100%" ? 682 : height - 60,
    rx: 8,
    fill: "url(#paint0_linear_9571_9252)",
    stroke: "url(#paint1_linear_9571_9252)",
    strokeOpacity: 0.24,
    vBox: "0 0 " + (width == "100%" ? 1305 : width) + " " + (height == "100%" ? 742 : height),
  }

  return (
    <div style={{
      zIndex: 1,
      top: 0,
      left: 0,
      padding: 0,
      margin: 0,
      width: "100%",
      height: "100%",
      position: "absolute",
      overflow: "visible"
    }}>
      <svg
        width={width}
        height={height}
        viewBox={sData.vBox}
        preserveAspectRatio={stretch ? "none" : undefined}
        fill="none"
        style={{
          overflow: "visible"
        }}
      >
        {/* <rect
        x={sData.x+0.5}
        y={sData.y+0.5}
        width={sData.width-1}
        height={sData.height-1}
        rx={sData.rx-0.5}
        stroke={sData.stroke}
        strokeWidth={1}
        strokeOpacity={sData.strokeOpacity} 
        fill={"rgba(255,255,255,0.1)"}
        // clipPath={"url(#bgblur_0_1_225_clip_path)"}
        /> */}

        {/* style={{
          backdropFilter: "blur(10px)"
        }} */}



        {/* Kept inside the card: the blobs are scaled past the viewBox and blurred
            through filters larger than it, so the glow used to spill over the page
            around the panel. Clipping to the panel's own rounded rect holds it
            where the card is. */}
        <g clipPath={`url(#panel_${uName})`}>
        <g opacity="0.2" transform="scale(1.142,1) translate(-200,-200)" >
       
    
              <g 
              // className="rotate-group"
              filter="url(#filter0_f_10343_11576)">
            <g clipPath="url(#paint0_angular_10343_11576_clip_path)" data-figma-skip-parse="true">
              <g transform="matrix(0.412827 0.331545 0.514307 -0.266126 760 540)">
                <foreignObject x="-1196.51" y="-1196.51" width="2393.01" height="2393.01">
                  <div xmlns="http://www.w3.org/1999/xhtml"
                    style={{
                      background: "conic-gradient(from 90deg,rgba(178, 59, 121, 1) 0deg,rgba(255, 0, 52, 1) 168.623deg,rgba(255, 91, 91, 1) 229.319deg,rgba(255, 167, 177, 1) 293.902deg,rgba(234, 168, 176, 1) 360deg)",
                      height: "100%",
                      width: "100%",
                      opacity: 1,
                      overflow: "visible"
                    }}>
                  </div></foreignObject>
              </g></g>
            />
          </g>
          <g filter="url(#filter1_f_10343_11576)"
          className="rotate-group">
            <g clipPath="url(#paint1_angular_10343_11576_clip_path)" data-figma-skip-parse="true"><g transform="matrix(-0.0258792 0.32761 0.508626 0.016669 869.5 583)">
              <foreignObject x="-886.189" y="-886.189" width="1772.38" height="1772.38">
                <div xmlns="http://www.w3.org/1999/xhtml"
                  style={{
                    background: "conic-gradient(from 90deg,rgba(43, 113, 208, 1) 0deg,rgba(5, 37, 80, 1) 246.639deg,rgba(135, 162, 199, 1) 360deg)",
                    height: "100%",
                    width: "100%",
                    opacity: 1,
                    overflow: "visible"
                  }}></div></foreignObject></g></g>
        
          </g>
        </g>
        </g>

        <foreignObject x={sData.x + 0.5} y={sData.y + 0.5} width={sData.width - 1} height={sData.height - 1}>
          <div xmlns="http://www.w3.org/1999/xhtml"
            className={frameless ? undefined : "main-bg-overlay"}
            style={{
              // background:"rgba(255, 255, 255, 0.1)",
              // borderRadius:8,
              // border:"1px solid rgba(255, 255, 255, 0.1)",
              // backdropFilter: "blur(110px)",
              // clipPath:"url(#bgblur_0_1_225_clip_path)",
              height: "calc(100% )",
              width: "calc(100%)",
              overflow: "visible"
            }}
          ></div>
        </foreignObject>


        <defs>
          <clipPath id={`panel_${uName}`}>
            <rect
              x={sData.x}
              y={sData.y}
              width={sData.width}
              height={sData.height}
              rx={sData.rx} />
          </clipPath>
          <clipPath id="clip">
            <rect x="140" y="20" width="120" height="100" />
          </clipPath>
          <filter id="blur" width="160%" height="160%" x="-30%" y="-30%">
            <feFlood floodColor="#fff" result="neutral" />
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blurred" />
            <feMerge>
              <feMergeNode in="neutral" />
              <feMergeNode in="blurred" />
            </feMerge>
          </filter>


          <clipPath id="bgblur_0_1_225_clip_path" transform="translate(0 0)">
            <path d="M30 23C30 18.5817 33.5817 15 38 15H1068C1072.42 15 1076 18.5817 1076 23V561C1076 565.418 1072.42 569 1068 569H38C33.5817 569 30 565.418 30 561V23Z" />
          </clipPath>

          <filter id="filter0_f_10343_11576" x="0" y="-21" width="1520" height="1122" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="100" result="effect1_foregroundBlur_10343_11576" />
          </filter>
          <clipPath id="paint0_angular_10343_11576_clip_path"><ellipse cx="560" cy="361" rx="560" ry="361" transform="matrix(-1 0 0 1 1320 179)" />
          </clipPath><filter id="filter1_f_10343_11576" x="41" y="-93" width="1657" height="1352" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="200" result="effect1_foregroundBlur_10343_11576" />
          </filter>
          <clipPath id="paint1_angular_10343_11576_clip_path"><ellipse cx="428.5" cy="276" rx="428.5" ry="276" transform="matrix(-1 0 0 1 1298 307)" /></clipPath>



          <filter
            id="filter0_ddd_9571_9252"
            x={0}
            y={-5}
            width={sData.width + 60}
            height={sData.height + 60}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dy={15} />
            <feGaussianBlur stdDeviation={15} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_9571_9252" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dy={2} />
            <feGaussianBlur stdDeviation={2} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_9571_9252"
              result="effect2_dropShadow_9571_9252" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dy={3} />
            <feGaussianBlur stdDeviation={3} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_9571_9252"
              result="effect3_dropShadow_9571_9252" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect3_dropShadow_9571_9252"
              result="shape" />
          </filter>
          <clipPath id="bgblur_0_9571_9252_clip_path" transform="translate(0 5)">
            <rect x={sData.x} y={sData.y} width={sData.width} height={sData.height} rx={sData.rx} />
          </clipPath>
          <linearGradient
            id="paint0_linear_9571_9252"
            x1="429.722"
            y1="14.9999"
            x2="464.381"
            y2="695.234"
            gradientUnits="userSpaceOnUse"
          >
            {isDarkMode ?
              <>
                <stop stopColor="#202020" />
                <stop offset={1} stopColor="#321B17" />
              </>
              :
              <>
                <stop stopColor="hsl(0, 0%, 95%)" />
                <stop offset={1} stopColor="hsl(0, 0%, 88%)" />
              </>}
          </linearGradient>
          <linearGradient
            id="paint1_linear_9571_9252"
            x1="382.75"
            y1="435.567"
            x2="737.164"
            y2="-211.422"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={isDarkMode ? "white" : "black"} stopOpacity={0} />
            <stop offset={1} stopColor={isDarkMode ? "white" : "black"} />
          </linearGradient>
        </defs>


      </svg>
      <svg
        style={{
          display: "none"
        }}
        width={width}
        height={height}
        viewBox={sData.vBox}
        fill="none"
      >
        <g filter="url(#filter0_ddd_9571_9252)">
          <rect
            x={sData.x}
            y={sData.y}
            width={sData.width}
            height={sData.height}
            rx={sData.rx}
            fill={sData.fill} />
          <rect
            x={sData.x + 0.5}
            y={sData.y + 0.5}
            width={sData.width - 1}
            height={sData.height - 1}
            rx={sData.rx - 0.5}
            stroke={sData.stroke}
            strokeOpacity={sData.strokeOpacity} />
          <rect
            x={sData.x + 0.5}
            y={sData.y + 0.5}
            width={sData.width - 1}
            height={sData.height - 1}
            rx={sData.rx - 0.5}
            stroke={sData.stroke}
            style={{ mixBlendMode: "overlay" }} />
        </g>

      </svg>
    </div>
  );
}
